import React, { Suspense, useRef, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Canvas } from "@react-three/fiber";
import { Box, OrbitControls } from "@react-three/drei";
import * as THREE from "three";
import Balkon from "../../../models/balkon";
import Environment from "../../../models/environment";
import ConstructorBar from "../../components/bar.constructor";
import { SceneEnvironment, ScenePostFX } from "../../components/scene.look";
import { CinematicLayer } from "../../components/cinematic";
import { CameraDirector } from "../../components/camera.director";
import ViewControls from "../../components/view.controls";
import { LightLevaPanel, isLevaEnabled } from "../../components/light.leva";
import useGlobal from "../../../store";
import Loading from "../../components/loading";
import PriceBar from "../../components/price.bar";
import cssIf from "../../../scripts/helpers/class.add.if";
import { Layers } from "three";
import lightSettings from "../../../settings/light";
import { ACTIVE_LOOK, getLookPreset } from "../../../settings/render";
import { useAdaptiveGfx } from "../../hooks/use.adaptive.gfx";
import canvasToPreviewDataUrl from "../../../scripts/helpers/canvas.preview";
import { accessLevel, featureAllowed } from "../../../settings/tariff.features";

const Constructor = () => {

  const navigate = useNavigate();

  const [ globalState, globalActions ] = useGlobal();

  const { 

    GLOBAL,

    balkon_isloaded, 
    balkon_type, 
    balkon_enter,

    selectedModelRef, 
    selectedModelPart,

    cupboard_left_full_added,
    cupboard_left_full_type, 
    cupboard_left_full_doors, 
    cupboard_left_full_position,
    cupboard_left_full_rotation,

    cupboard_left_tumb_added,
    cupboard_left_tumb_doors, 
    cupboard_left_tumb_position,
    cupboard_left_tumb_rotation,

    cupboard_left_top_added,
    cupboard_left_top_type, 
    cupboard_left_top_doors, 
    cupboard_left_top_position,
    cupboard_left_top_rotation,

    cupboard_left_bottom_added,
    cupboard_left_bottom_type, 
    cupboard_left_bottom_doors, 
    cupboard_left_bottom_position,
    cupboard_left_bottom_rotation,
    
    cupboard_right_full_added,
    cupboard_right_full_type, 
    cupboard_right_full_doors, 
    cupboard_right_full_position,
    cupboard_right_full_rotation,
    
    cupboard_right_tumb_added,
    cupboard_right_tumb_doors, 
    cupboard_right_tumb_position,
    cupboard_right_tumb_rotation,
    
    cupboard_right_top_added,
    cupboard_right_top_type, 
    cupboard_right_top_doors, 
    cupboard_right_top_position,
    cupboard_right_top_rotation,
    
    cupboard_right_bottom_added,
    cupboard_right_bottom_type, 
    cupboard_right_bottom_doors, 
    cupboard_right_bottom_position,
    cupboard_right_bottom_rotation,
    
    lar_left_added,
    lar_left_position,
    lar_left_rotation,
    
    lar_right_added,
    lar_right_position,
    lar_right_rotation,

  } = globalState;

  const { changeStates, constructor } = globalActions;
  const { setTexture, syncTextures } = constructor;

  const refGL = useRef( null );
  const controlsRef = useRef( null );
  const cameraApiRef = useRef( null );

  const ligthRef = useRef();
  const boxRef = useRef();
  const dirRef = useRef();

  const applyTextureBalkon = useRef();
  
  const applyTextureCupboardLeftFull = useRef();
  const applyTextureCupboardLeftTumb = useRef();
  const applyTextureCupboardLeftTop = useRef();
  const applyTextureCupboardLeftBottom = useRef();

  const applyTextureCupboardRightFull = useRef();
  const applyTextureCupboardRightTumb = useRef();
  const applyTextureCupboardRightTop = useRef();
  const applyTextureCupboardRightBottom = useRef();

  const applyTextureLarLeft = useRef();
  const applyTextureLarRight = useRef();

  const APPLY_TEXTURE_FUNCS = {

    balkon: applyTextureBalkon,

    cupboard_left_full: applyTextureCupboardLeftFull,
    cupboard_left_tumb: applyTextureCupboardLeftTumb,
    cupboard_left_top: applyTextureCupboardLeftTop,
    cupboard_left_bottom: applyTextureCupboardLeftBottom,

    cupboard_right_full: applyTextureCupboardRightFull,
    cupboard_right_tumb: applyTextureCupboardRightTumb,
    cupboard_right_top: applyTextureCupboardRightTop,
    cupboard_right_bottom: applyTextureCupboardRightBottom,

    lar_left: applyTextureLarLeft,
    lar_right: applyTextureLarRight,

  }

  // LEVA controls
 
  // const ambientLightSettings = useControls('ambientLight', {
  //   intensity: { value: lightSettings[ +balkon_type ].ambient.intensity, min: 0, max: 3.5, step: 0.01 }
  // });

  // let lightTargetSettings = useControls('lightTargetSettings', {

  //   posX: { value: lightSettings[ +balkon_type ].target.x, min: -150, max: 150, step: 0.01 }, 
  //   posY: { value: lightSettings[ +balkon_type ].target.y, min: -150, max: 150, step: 0.01 }, 
  //   posZ: { value: lightSettings[ +balkon_type ].target.z, min: -150, max: 150, step: 0.01 },

  // });

  // const directionallightSettings = useControls('DirectionalLight', {

  //   posX: { value: lightSettings[ +balkon_type ].directional.x, min: -150, max: 150, step: 0.01 }, 
  //   posY: { value: lightSettings[ +balkon_type ].directional.y, min: -150, max: 150, step: 0.01 }, 
  //   posZ: { value: lightSettings[ +balkon_type ].directional.z, min: -150, max: 150, step: 0.01 },
  //   intensity: { value: lightSettings[ +balkon_type ].directional.intensity, min: 0, max: 2.5, step: 0.01 },

  // });

  // const spotlightSettings = useControls('SpotLight', {

  //   posX: { value: lightSettings[ +balkon_type ].spot.x, min: -100, max: 100, step: 0.05 }, 
  //   posY: { value: lightSettings[ +balkon_type ].spot.y, min: -100, max: 100, step: 0.05 }, 
  //   posZ: { value: lightSettings[ +balkon_type ].spot.z, min: -100, max: 100, step: 0.05 },

  //   intensity: { value: lightSettings[ +balkon_type ].spot.intensity, min: 0, max: 2.5, step: 0.01 },
  //   angle: { value: 2.9, min: 0, max: 3.14, step: 0.1 },
  //   decay: { value: lightSettings[+balkon_type].spot.decay, min: -5, max: 5, step: 0.01 },

  // });
 
  // off LEVA conftols (production)

  const [ lookId, setLookId ] = useState( ACTIVE_LOOK );
  const look = getLookPreset( lookId );
  const gfx = useAdaptiveGfx( true );
  const [ godSun, setGodSun ] = useState( null );
  const [ lightOverride, setLightOverride ] = useState( null );
  const [ exposureOverride, setExposureOverride ] = useState( null );
  const [ frameloop, setFrameloop ] = useState( 'always' );
  const levaOn = isLevaEnabled();

  const lights = lightOverride || lightSettings[ +balkon_type ];
  const exposure = exposureOverride ?? look.exposure;

  useEffect(() => {

    if ( refGL.current ) {

      refGL.current.toneMappingExposure = exposure;

    }

  }, [ exposure, lookId ]);

  // Pause WebGL when the tab is hidden — keeps memory/CPU in budget (§11)
  useEffect(() => {

    const onVis = () => {

      setFrameloop( document.hidden ? 'never' : 'always' );

    };

    document.addEventListener( 'visibilitychange', onVis );

    return () => document.removeEventListener( 'visibilitychange', onVis );

  }, []);

  const ambientLightSettings = {
    intensity: lights.ambient.intensity * look.ambientScale
  }

  const lightTargetSettings = {

    posX: lights.target.x, 
    posY: lights.target.y, 
    posZ: lights.target.z

  }

  const directionallightSettings = {

    posX: lights.directional.x, 
    posY: lights.directional.y, 
    posZ: lights.directional.z,
    intensity: lights.directional.intensity * look.directionalScale,

  }

  const spotlightSettings = {

    posX: lights.spot.x,
    posY: lights.spot.y,
    posZ: lights.spot.z,

    intensity: lights.spot.intensity * look.spotScale,
    angle: 2.9,
    decay: lights.spot.decay,

  }

  const hemisphereSettings = {

    skyColor: look.hemisphere.skyColor,
    groundColor: look.hemisphere.groundColor,
    intensity: look.hemisphere.intensity,

  }

  function takeScreenShot() {

    const gl = refGL.current;

    if ( !gl?.domElement ) return Promise.resolve( '' );

    return new Promise(( resolve ) => {

      requestAnimationFrame(() => {

        requestAnimationFrame(() => {

          try {

            resolve( canvasToPreviewDataUrl( gl.domElement ) );

          } catch ( err ) {

            console.warn( 'takeScreenShot failed', err );
            resolve( '' );

          }

        });

      });

    });

  }

  function snapCamera( id ) {

    cameraApiRef.current?.snapToPreset( id );

  }

  const syncTexturesRef = ( syncTarget = false ) => { 
    
    syncTextures( 
      
      APPLY_TEXTURE_FUNCS?.[ syncTarget || selectedModelRef ]?.current, 
      syncTarget
      
    ); 
  
  }

  useEffect(() => {

    if (!globalState.user_id) return;
    if (!featureAllowed(accessLevel(globalState.tariff), 'projects')) return;
    if (!balkon_isloaded) navigate('/');

  }, [ globalState.user_id, globalState.tariff, balkon_isloaded ]);

  useEffect(() => { 

    if ( GLOBAL.BALKONS.length > 0 ) {
    
      let balkon = GLOBAL.BALKONS.find( b => b.id === balkon_type );
      balkon = balkon.model.replace('.glb', '');

      const variants = {

        1: "",
        2: "_v2",
        3: "_v3",

      }

      const modelUrl = `${ balkon }${ variants[ +balkon_enter ] }.glb`;

      changeStates({ balkon_model: modelUrl });
    
    }

    console.log( `-------------` );
    console.log( `store.state`, globalState );
    console.log( `-------------` );
    console.log( `store.actions`, globalActions );
    console.log( `-------------` );
    console.log( `-------------` );
  
  }, [ balkon_enter ]);

  const layers = new Layers()
  layers.enable( 1 )

  // Keep light targets pointed at the invisible Box (window sun aim)
  useEffect(() => {

    const syncTargets = () => {

      if ( !boxRef.current || !ligthRef.current || !dirRef.current ) return;

      ligthRef.current.target.position.copy( boxRef.current.position );
      ligthRef.current.target.updateMatrixWorld();

      dirRef.current.target.position.copy( boxRef.current.position );
      dirRef.current.target.updateMatrixWorld();

    };

    syncTargets();
    const t1 = setTimeout( syncTargets, 50 );
    const t2 = setTimeout( syncTargets, 300 );

    return () => {

      clearTimeout( t1 );
      clearTimeout( t2 );

    };

  }, [

    lightTargetSettings.posX,
    lightTargetSettings.posY,
    lightTargetSettings.posZ,
    balkon_type,

  ]);
  
  return (

    <React.Fragment>

      <PriceBar />

      <ConstructorBar

        selectedPartName = { selectedModelPart }
        setTexture = { ( obj ) => setTexture( obj, APPLY_TEXTURE_FUNCS?.[ selectedModelRef ]?.current ) }
        takeScreenShot = { takeScreenShot }

      />

      {/* <ViewControls

        onSnap = { snapCamera }
        lookId = { lookId }
        onLookChange = { setLookId }

      /> */}

      { levaOn && (

        <LightLevaPanel

          balkonType = { balkon_type }
          lookExposure = { look.exposure }
          onLightOverride = { setLightOverride }
          onExposureOverride = { setExposureOverride }

        />

      )}

      <Suspense fallback={ <Loading /> }>

        <Canvas

          key = { `gfx-${ gfx.id }-${ gfx.shadowMapSize }` }
          frameloop = { frameloop }
          shadows 
          colorManagement
          shadowMap
          dpr = {[ 1, gfx.dprMax ]}
          camera = {{

            //// position: [ 5, 0, 0.01 ], //? Позиция камеры извне для дебага расположения шкафов. Чтобы сработало, нужно закомментить maxDistance в OrbitControls (внизу)
            position: [ 0, 0, -1.01 ],
            // fov: 60, // кинематографичный вариант — раскомментировать и закомментировать строку ниже
            fov: 100, // широкий угол для узкого балкона

          }}
          gl={{

            preserveDrawingBuffer: true,
            antialias: !!gfx.antialias,
            powerPreference: gfx.powerPreference || 'default',
            toneMapping: THREE.ACESFilmicToneMapping,
            outputEncoding: THREE.sRGBEncoding,

          }}
          onCreated={({ gl }) => {

            refGL.current = gl;
            gl.preserveDrawingBuffer = true;
            gl.toneMapping = THREE.ACESFilmicToneMapping;
            gl.toneMappingExposure = exposure;
            gl.outputEncoding = THREE.sRGBEncoding;
            gl.shadowMap.enabled = true;
            gl.shadowMap.type = THREE.PCFSoftShadowMap;

          }}

        >

          <color attach = "background" args = {[ look.background ]} />

          <SceneEnvironment look = { look } />

          <CinematicLayer onSunReady = { setGodSun } look = { look } />

          <CameraDirector apiRef = { cameraApiRef } controlsRef = { controlsRef } />
          
          <Balkon
          
            syncTextures = { syncTexturesRef }
            refDOM = { applyTextureBalkon }

          />
          
          { lar_left_added &&

            <Environment

              id = "lar_left"
              model = { `models/lar/lar${ cssIf( +balkon_type === 5, "_small" )}.glb` }
              // position = {[ -0.9, -1.4, -0.02 ]}
              // rotationY = { 0 } 
              position = { lar_left_position }
              rotationY = { lar_left_rotation } 
              refDOM = { applyTextureLarLeft }
              syncTextures = { syncTexturesRef }
              onClick = { lar_left_added ? () => globalActions.environment.openLarSettings('left') : undefined }

            />

          }
          
          { lar_right_added &&

            <Environment

              id = "lar_right"
              model = { `models/lar/lar${ cssIf( +balkon_type === 5, "_small" )}.glb` }
              // position = {[ -0.36, -1.4, 0.01 ]}
              // rotationY = { 3.16 } 
              position = { lar_right_position }
              rotationY = { lar_right_rotation } 
              refDOM = { applyTextureLarRight }
              syncTextures = { syncTexturesRef }
              onClick = { lar_right_added ? () => globalActions.environment.openLarSettings('right') : undefined }

            />

          }
          
          { cupboard_left_full_added &&

            <Environment

              id = "cupboard_left_full"
              model = { `models/cupboards/cupboard_${ balkon_type }_${ cupboard_left_full_doors }_${ cupboard_left_full_type }.glb` }
              // position = {[ -1.53, -1.7, 0.19 ]}
              // rotationY = { 3.2 } 
              position = { cupboard_left_full_position }
              rotationY = { cupboard_left_full_rotation } 
              refDOM = { applyTextureCupboardLeftFull }
              syncTextures = { syncTexturesRef }
              onClick = { cupboard_left_full_added ? () => globalActions.environment.openCupboardSettings('left_full') : undefined }

            />

          }
          
          { cupboard_left_tumb_added &&

            <Environment

              id = "cupboard_left_tumb"
              model = { `models/cupboards/cupboard_${ balkon_type }_${ cupboard_left_tumb_doors }_tumb_left.glb` }
              // position = {[ -1.53, -1.7, 0.19 ]}
              // rotationY = { 3.2 } 
              position = { cupboard_left_tumb_position }
              rotationY = { cupboard_left_tumb_rotation } 
              refDOM = { applyTextureCupboardLeftTumb }
              syncTextures = { syncTexturesRef }
              onClick = { cupboard_left_tumb_added ? () => globalActions.environment.openCupboardSettings('left_tumb') : undefined }

            />

          }
          
          { cupboard_left_top_added &&

            <Environment

              id = "cupboard_left_top"
              model = { `models/cupboards/cupboard_${ balkon_type }_${ cupboard_left_top_doors }_${ cupboard_left_top_type }.glb` }
              // position = {[ -1.53, -1.7, 0.05 ]}
              // rotationY = { 3.2 } 
              position = { cupboard_left_top_position }
              rotationY = { cupboard_left_top_rotation } 
              refDOM = { applyTextureCupboardLeftTop }
              syncTextures = { syncTexturesRef }
              onClick = {cupboard_left_top_added ? () => globalActions.environment.openCupboardSettings('left_top') : undefined }

            />

          }
          
          { cupboard_left_bottom_added &&

            <Environment

              id = "cupboard_left_bottom"
              model = { `models/cupboards/cupboard_${ balkon_type }_${ cupboard_left_bottom_doors }_${ cupboard_left_bottom_type }.glb` }
              // position = {[ -1.53, -1.7, 0.05 ]}
              // rotationY = { 3.2 } 
              position = { cupboard_left_bottom_position }
              rotationY = { cupboard_left_bottom_rotation } 
              refDOM = { applyTextureCupboardLeftBottom }
              syncTextures = { syncTexturesRef }
              onClick = { cupboard_left_bottom_added ? () => globalActions.environment.openCupboardSettings('left_bottom') : undefined }

            />

          }
          
          { cupboard_right_full_added &&

            <Environment

              id = "cupboard_right_full"
              model = { `models/cupboards/cupboard_${ balkon_type }_${ cupboard_right_full_doors }_${ cupboard_right_full_type }.glb` }
              // position = {[ -0.45, -1.4, 0.2 ]}
              // rotationY = { cupboard_right_full_rotation } 
              position = { cupboard_right_full_position }
              rotationY = { cupboard_right_full_rotation } 
              refDOM = { applyTextureCupboardRightFull }
              syncTextures = { syncTexturesRef }
              onClick = { cupboard_right_full_added ? () => globalActions.environment.openCupboardSettings('right_full') : undefined }

            />

          }
          
          { cupboard_right_tumb_added &&

            <Environment

              id = "cupboard_right_tumb"
              model = { `models/cupboards/cupboard_${ balkon_type }_${ cupboard_right_tumb_doors }_tumb_right.glb` }
              // position = {[ -1.11, -1.7, 0.1 ]}
              // rotationY = { cupboard_right_rotation } 
              position = { cupboard_right_tumb_position }
              rotationY = { cupboard_right_tumb_rotation } 
              refDOM = { applyTextureCupboardRightTumb }
              syncTextures = { syncTexturesRef }
              onClick = { cupboard_right_tumb_added ? () => globalActions.environment.openCupboardSettings('right_tumb') : undefined }

            />

          }
          
          { cupboard_right_top_added &&

            <Environment

              id = "cupboard_right_top"
              model = { `models/cupboards/cupboard_${ balkon_type }_${ cupboard_right_top_doors }_${ cupboard_right_top_type }.glb` }
              // position = {[ -1.11, -1.7, 0.1 ]}
              // rotationY = { cupboard_right_rotation } 
              position = { cupboard_right_top_position }
              rotationY = { cupboard_right_top_rotation } 
              refDOM = { applyTextureCupboardRightTop }
              syncTextures = { syncTexturesRef }
              onClick = { cupboard_right_top_added ? () => globalActions.environment.openCupboardSettings('right_top') : undefined }

            />

          }
          
          { cupboard_right_bottom_added &&

            <Environment

              id = "cupboard_right_bottom"
              model = { `models/cupboards/cupboard_${ balkon_type }_${ cupboard_right_bottom_doors }_${ cupboard_right_bottom_type }.glb` }
              // position = {[ -1.11, -1.7, 0.1 ]}
              // rotationY = { cupboard_right_rotation } 
              position = { cupboard_right_bottom_position }
              rotationY = { cupboard_right_bottom_rotation } 
              refDOM = { applyTextureCupboardRightBottom }
              syncTextures = { syncTexturesRef }
              onClick = { cupboard_right_bottom_added ? () => globalActions.environment.openCupboardSettings('right_bottom') : undefined }

            />

          }            

          <ambientLight 

            layers={layers} 
            intensity={ambientLightSettings.intensity} 

          />

          <hemisphereLight

            args = {[ hemisphereSettings.skyColor, hemisphereSettings.groundColor, hemisphereSettings.intensity ]}
            layers = { layers }

          />

          <Box

            visible    = { false }
            color      = "#000000"
            ref        = { boxRef }
            scale      = {[ 0.2, 0.2, 0.2 ]}
            castShadow = { false }
            position   = {[ lightTargetSettings.posX, lightTargetSettings.posY, lightTargetSettings.posZ ]}
            size       = {[ 0.1, 0.1, 0.1 ]} 

          />

          <spotLight

            ref       = {ligthRef}
            intensity = { spotlightSettings.intensity } 
            angle     = { spotlightSettings.angle } 
            decay     = { spotlightSettings.decay } 
            penumbra  = { 1 } 
            position  = {[ spotlightSettings.posX, spotlightSettings.posY, spotlightSettings.posZ ]}
            color     = { look.spotColor }
            layers    = {layers}

          />

          <directionalLight

            castShadow
            ref       = { dirRef }
            layers    = { layers }
            position  = {[ directionallightSettings.posX, directionallightSettings.posY, directionallightSettings.posZ ]}
            intensity = { directionallightSettings.intensity }
            color     = { look.directionalColor }
            shadow-bias           = { -0.0004 }
            shadow-normalBias     = { 0.01 }
            shadow-camera-near    = { 1 }
            shadow-camera-far     = { 250 }
            shadow-camera-left   = { -10 }
            shadow-camera-right  = {  10 }
            shadow-camera-top    = {  10 }
            shadow-camera-bottom = { -10 }
            shadow-mapSize       = {[ gfx.shadowMapSize, gfx.shadowMapSize ]}

          />

          {/* Soft bounce from sunlit floor / opposite wall — lifts shadowed corners without killing contrast */}
          <pointLight

            intensity = { 0.22 * look.directionalScale }
            distance = { 8 }
            decay = { 2 }
            color = { look.directionalColor }
            position = {[
              lightTargetSettings.posX * 0.15,
              -0.85,
              lightTargetSettings.posZ * 0.15,
            ]}
            layers = { layers }

          />

          <OrbitControls 

            ref = { controlsRef }
            enablePan = { true }
            enableZoom = { true } 
            enableDamping = { true }
            
            minPolarAngle = { 0 }
            maxPolarAngle = { Math.PI }
            maxAzimuthAngle = { Math.PI / 2 }

            maxDistance = { 0.51 } //// закомментить, когда надо камеру вынести за пределы балкона

          />

          <ScenePostFX look = { look } sun = { godSun } />

          {/* <axesHelper 
          
            args = {[ 5 ]}
            position = {[ directionallightSettings.posX, directionallightSettings.posY, directionallightSettings.posZ ]}
            
          />

          <axesHelper 
          
            args = {[ 5 ]}
            position = {[ spotlightSettings.posX, spotlightSettings.posY, spotlightSettings.posZ ]}
            
          />

          <axesHelper 
          
            args = {[ 5 ]}
            position={[ lightTargetSettings.posX, lightTargetSettings.posY, lightTargetSettings.posZ ]}
            
          /> */}

        </Canvas>

      </Suspense>

    </React.Fragment>

  );

}

export default Constructor;